import { useBatchIdAtLoad } from 'api/elplan/bidSubmissions.api'
import type { IntradayBatchIdReading } from 'api/elplan/elplan.types'
import { useState } from 'react'
import { getPrefillWindow } from '../../../helpers/intradayBidSubmissions.helper'

type SubmissionBaseline = {
  systemId: number
  batchId: IntradayBatchIdReading
}

type SubmissionBaselineInput = {
  systemId: number | undefined
  bidBaseStartTime: Date
  hasBidInput: boolean
}

export function useSubmissionBaseline({ systemId, bidBaseStartTime, hasBidInput }: SubmissionBaselineInput) {
  const { startTime, endTime } = getPrefillWindow(bidBaseStartTime)
  const batchIdAtLoad = useBatchIdAtLoad(hasBidInput ? (systemId ?? 0) : 0, startTime, endTime)
  const [baseline, setBaseline] = useState<SubmissionBaseline>()

  if (systemId !== undefined && batchIdAtLoad.isSuccess && baseline?.systemId !== systemId) {
    setBaseline({ systemId, batchId: batchIdAtLoad.data })
  }

  const baselineBatchId: IntradayBatchIdReading =
    baseline !== undefined && baseline.systemId === systemId ? baseline.batchId : 'unknown'

  function recordSubmittedBatch(submittedSystemId: number, batchId: number): void {
    setBaseline({ systemId: submittedSystemId, batchId })
  }

  function retakeBaseline(reloadedSystemId: number): void {
    setBaseline((current) => (current?.systemId === reloadedSystemId ? undefined : current))
  }

  return { baselineBatchId, recordSubmittedBatch, retakeBaseline }
}
